import { InventoryStatus } from '@noths/polaris-dev-ts-types';

import { isOutOfStock } from '.';

interface GetDisplayPageLoadPlacements {
  inventoryStatus: InventoryStatus;
  available: boolean;
  showSimilarProducts: boolean | undefined;
  similarProductsPlacementHasData: boolean;
  recentlyViewedPlacementHasData: boolean;
  activeProductsPlacementHasData: boolean;
  outOfStockPlacementHasData: boolean;
}

export const getDisplayPageLoadPlacements = ({
  inventoryStatus,
  available,
  showSimilarProducts,
  similarProductsPlacementHasData,
  recentlyViewedPlacementHasData,
  activeProductsPlacementHasData,
  outOfStockPlacementHasData,
}: GetDisplayPageLoadPlacements) => {
  const displaySimilarProductsPlacement =
    showSimilarProducts &&
    !isOutOfStock(inventoryStatus) &&
    available &&
    similarProductsPlacementHasData;

  const displayRecentlyViewedPlacement =
    !isOutOfStock(inventoryStatus) && recentlyViewedPlacementHasData;

  const displayActiveProductsPlacement =
    !isOutOfStock(inventoryStatus) && activeProductsPlacementHasData;

  const displayOutOfStockPlacement = isOutOfStock(inventoryStatus) && outOfStockPlacementHasData;

  return {
    displaySimilarProductsPlacement,
    displayRecentlyViewedPlacement,
    displayActiveProductsPlacement,
    displayOutOfStockPlacement,
  };
};
